import type { SVGProps } from 'react';

const SvgSmartSendTime = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="smart-send-time">
      <path d="M4.6 10.88h13.49v1.5H4.6zM4.6 15.9h10.87v1.5H4.6zM25.25 20.32h-1.5v4.25a.75.75 0 0 0 .75.75h4.31v-1.5h-3.56Z" />
      <path d="M2 24.17V7.83h23.3v7.8h1.5V3A2.71 2.71 0 0 0 24.05.28H3.18A2.71 2.71 0 0 0 .46 3v21.17a2.72 2.72 0 0 0 2.72 2.71h12.6v-1.5H3.18A1.22 1.22 0 0 1 2 24.17M3.18 1.78h20.87A1.21 1.21 0 0 1 25.26 3v3.33H2V3a1.22 1.22 0 0 1 1.18-1.22" />
      <path d="M24.5 17.46a7.17 7.17 0 1 0 7.17 7.16 7.17 7.17 0 0 0-7.17-7.16m0 12.83a5.67 5.67 0 1 1 5.67-5.67 5.68 5.68 0 0 1-5.67 5.67M4.43 3.39h2.48v1.5H4.43zM8.89 3.39h2.48v1.5H8.89z" />
    </g>
  </svg>
);

export default SvgSmartSendTime;
